// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__zyJwn","requiredAsterisk":"Info_requiredAsterisk__kfmF4"};